import actions from "./actions";

const initState = {

    dealers: [],
    createDealerLoading: false,
    createDealerError: null,
    createDealerMessage: null,

    dealerList: [],
    getDealerListLoading: false,
    getDealerListError: null,

    // Modify Dealer
    modifyDealerLoading: false,
    modifyDealerError: null,
    modifyDealerMessage: null,

    // Reset Admin Password
    resetPasswordByAdminLoading: false,
    resetPasswordByAdminError: null,
    resetPasswordByAdminMessage: null,
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.CREATE_DEALER:
            return {
                ...state,
                dealers: [],
                createDealerLoading: true,
                createDealerError: null,
            };
        case actions.CREATE_DEALER_SUCCESS:
            return {
                ...state,
                dealers: action.data,
                createDealerLoading: false,
                createDealerError: null,
                createDealerMessage: action.message,
            };
        case actions.CREATE_DEALER_FAILED:
            return {
                ...state,
                createDealerLoading: false,
                createDealerError: action.error,
                createDealerMessage: null,
            }
        // Dealer List
        case actions.GET_DEALER_LIST:
            return {
                ...state,
                getDealerListLoading: true,
                getDealerListError: null,
            };
        case actions.GET_DEALER_LIST_SUCCESS:
            return {
                ...state,
                dealerList: action.payload.data,
                getDealerListLoading: false,
                getDealerListError: null,
            };
        case actions.GET_DEALER_LIST_FAILED:
            return {
                ...state,
                getDealerListLoading: false,
                getDealerListError: action.error,
            }

        // MODIFY DEALER

        case actions.MODIFY_DEALER:
            return {
                ...state,
                modifyDealerLoading: true,
                modifyDealerError: null,
                modifyDealerMessage: null,
            };

        case actions.MODIFY_DEALER_SUCCESS:
            return {
                ...state,
                modifyDealerLoading: false,
                modifyDealerError: null,
                modifyDealerMessage:
                    action.message,
            };

        case actions.MODIFY_DEALER_FAILED:
            return {
                ...state,
                modifyDealerLoading: false,
                modifyDealerError: action.error,
                modifyDealerMessage: null,
            };
        // Reset Admin Password

        case actions.RESET_PASSWORD_BY_ADMIN:
            return {
                ...state,
                resetPasswordByAdminLoading: true,
                resetPasswordByAdminError: null,
                resetPasswordByAdminMessage: null,
            };

        case actions.RESET_PASSWORD_BY_ADMIN_SUCCESS:
            return {
                ...state,
                resetPasswordByAdminLoading: false,
                resetPasswordByAdminError: null,
                resetPasswordByAdminMessage: action.message,
            };

        case actions.RESET_PASSWORD_BY_ADMIN_FAILED:
            return {
                ...state,
                resetPasswordByAdminLoading: false,
                resetPasswordByAdminError: action.error,
                resetPasswordByAdminMessage: null,
            };

        case actions.RESET_MESSAGE:
            return {
                ...state,

                createDealerMessage: null,
                createDealerError: null,
                getDealerListError: null,
                modifyDealerMessage: null,
                modifyDealerError: null,
                resetPasswordByAdminMessage: null,
                resetPasswordByAdminError: null,
                fundManagementError: null,
                fundManagementMessage: null,
            };
        default:
            return state;
    }
}
